import { Card } from "@/components/ui/card";

interface ErrorStateProps {
  message: string;
}

export const ErrorState = ({ message }: ErrorStateProps) => {
  return (
    <Card className="p-6">
      <p>{message}</p>
    </Card>
  );
};